import type { RootState } from 'src/redux/store'
import {
  createOrderItemsSelector,
  createPromotionalOrderItemsSelector
} from 'selectors/order-items'

interface ThankyouSelector {
  checkoutResults: Oms.V4.CheckoutResults
  validateTokenResults: {
    status: string
    error?: string
    data: Record<string, unknown>
  }
  trackingDeliveryResults: {
    status: string
    error?: string
    data: Record<string, string>
  }
}

export const selectThankyou = (state: RootState): ThankyouSelector =>
  state['@thankyou']

const getOrderItemsFromState = (state) =>
  state['@thankyou'].checkoutResults.status === 'fulfilled'
    ? (state['@thankyou'].checkoutResults.data.storeOrder || {})
      .orderItems // From payment redirection
    : (state['@checkout'].meta.data.storeOrder || {}).orderItems // From checkout page

export const selectOrderItems = (state: RootState): Oms.V4.OrderItem[] =>
  createOrderItemsSelector(getOrderItemsFromState)(state)

export const selectPromotionalOrderItems = (
  state: RootState
): Oms.V4.OrderItem[] =>
  createPromotionalOrderItemsSelector(getOrderItemsFromState)(state)
